module.exports = __webpack_public_path__ + "media/conversa/logo_sofia_color-df15ff5f.webp";